import { IContentType } from "../interfaces/content/content-type-model.interface";

export class ContentTypeModel implements IContentType {
    public contentTypeId: number;
    public name: string;
    public description: string;

    constructor() {
        this.contentTypeId = 0;
        this.name = "";
        this.description = "";
    }
}
